import { Box, Typography } from "@mui/material";
import ActionButton from "components/Buttons/ActionButton";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Box
      component="main"
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        overflow: "hidden",
        img: { mt: 3, mb: 4, ml: 3 },
      }}
    >
      <Typography>Uh-oh, this page doesn't seem to exist.</Typography>
      <img src="/images/logo-vidlet-butterfly.png" alt="Vidlet Logo" />
      <ActionButton onClick={() => navigate("/dashboard")}>
        go to dashboard
      </ActionButton>
    </Box>
  );
}
